export function downloadFile(filename: string, data: string, type = "text/plain"): void {
    const blob = new Blob([data], { type });
    downloadBlob(filename, blob);
}

export function downloadBlob(filename: string, blob: Blob): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

/**
 * Returns a formatted string representation of the file size.
 * If the size is less than 1 MB, it will be displayed in KB.
 * If the size is 1 MB or greater, it will be displayed in MB.
 */
export function getFileSizeString(size: number): string {
    const kb = size / 1024;
    if (kb < 1024) {
        return `${kb.toFixed(2)} KB`;
    }

    const mb = kb / 1024;
    return `${mb.toFixed(2)} MB`;
}
